import { Toast } from '../../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../../interfaces/log.interface';
import { callAPI } from '../../../../services/api.service';

export interface CountryAdminModel {
  id: string;
  name: string;
  code: string;
  isDefault: boolean;
  isActive: boolean;
  displayOrder: number;
  createdAt?: any;
  updatedAt?: any;
}

export const getAdminCountries = async (
  setCountries: (countries: CountryAdminModel[]) => void,
  setTotalPages: (totalPages: number) => void,
  page?: number,
  search?: string,
  active?: string,
  setTotalRecords?: (total: number) => void,
) => {
  try {
    const params = new URLSearchParams();
    if (page) params.set('page', String(page));
    if (search) params.set('search', search);
    if (active !== undefined && active !== '') params.set('active', active);
    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await callAPI(`admin/country${qs}`);
    if (response?.countries) {
      setCountries(response.countries);
      setTotalPages(response.totalPages ?? 0);
      setTotalRecords?.(response.totalRecords ?? 0);
    } else {
      Toast('Failed to get countries', true);
    }
  } catch {
    Toast('Failed to get countries', true);
  }
};

export const saveCountry = async (
  data: Partial<CountryAdminModel>,
  onSuccess: () => void,
) => {
  try {
    const response = await callAPI('admin/country/save', data);
    if (response?.status === HTTPStatusEnum.OK) {
      Toast(data.id ? 'Country updated successfully' : 'Country created successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to save country', true);
    }
  } catch {
    Toast('Failed to save country', true);
  }
};

export const deleteCountry = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/country/delete', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Country deleted successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to delete country', true);
    }
  } catch {
    Toast('Failed to delete country', true);
  }
};

export const setDefaultCountry = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/country/set-default', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Default country updated');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to set default country', true);
    }
  } catch {
    Toast('Failed to set default country', true);
  }
};

export const toggleCountryStatus = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/country/status', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Country status updated');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to update country status', true);
    }
  } catch {
    Toast('Failed to update country status', true);
  }
};

export const reorderCountries = async (
  orderedIds: string[],
  onSuccess?: () => void,
) => {
  try {
    const response = await callAPI('admin/country/reorder', { orderedIds });
    if (response?.status === HTTPStatusEnum.OK) {
      onSuccess?.();
    } else {
      Toast(response?.message || 'Failed to save order', true);
    }
  } catch {
    Toast('Failed to save order', true);
  }
};
